export default __webpack_public_path__ + "static/media/a4.73269b81.png";